import { useEffect, type FC } from "react";
import type { MediaDescriptor } from "../utils/mediaBlock";
import { sizeClasses } from "../utils/mediaSize";
import { useRichMedia } from "../contexts/RichMediaContext";

interface MessageMediaProps {
  descriptor: MediaDescriptor;
}

/**
 * Renders a validated media descriptor (from a ```lastbot-media``` block) as a
 * sized container whose child media fills it. The container always fills the
 * content width; an aspect token makes it a fixed-ratio box (object-fit: cover).
 */
const MessageMedia: FC<MessageMediaProps> = ({ descriptor }) => {
  const { reportMedia } = useRichMedia();
  const className = [
    "lastbot-media-container",
    ...sizeClasses(`full ${descriptor.aspect ?? ""}`),
  ].join(" ");

  useEffect(() => {
    reportMedia();
  }, [reportMedia]);

  return (
    <div className={className}>
      {descriptor.type === "video" ? (
        <video
          src={descriptor.src}
          poster={descriptor.poster}
          aria-label={descriptor.alt}
          controls
          playsInline
          preload="metadata"
        />
      ) : (
        <img src={descriptor.src} alt={descriptor.alt ?? ""} />
      )}
    </div>
  );
};

export default MessageMedia;
